import type { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

/*
 * shadcn/ui Card (new-york), copied in following the STR-1004 precedent in
 * `MedScoutAI/artifacts/ui`. Changes from upstream: `cn` is `twMerge`, colors
 * are the app's `neutral-*` classes, and `space-y-*` is `gap-*` (no margins).
 */

export function Card({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card"
      className={twMerge(
        'flex flex-col rounded-2xl border border-neutral-300 bg-white text-neutral-900 shadow-sm',
        className
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-header"
      className={twMerge('flex flex-col gap-1 px-4 pt-4', className)}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-title"
      className={twMerge('font-semibold leading-tight', className)}
      {...props}
    />
  );
}

export function CardDescription({
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-description"
      className={twMerge('text-xs text-neutral-500', className)}
      {...props}
    />
  );
}

export function CardContent({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-content"
      className={twMerge('flex flex-col gap-3 p-4', className)}
      {...props}
    />
  );
}
